// extracted by mini-css-extract-plugin
export default {"bgVideoWrapper":"StartBgVideoWord_bgVideoWrapper__Sz4RD","unvisible":"StartBgVideoWord_unvisible__-S1yZ"};